import React from 'react';
import ConnectedPlatform from '../../../shared/ConnectedPlatform';

const Connected = (props) => (
    <ConnectedPlatform
        {...props}
        platformName='BigCommerce'
        domainSuffix='.mybigcommerce.com'
        dataTestIdPrefix='bigcommerce'
    />
);

export default Connected;
